import { render, staticRenderFns } from "./BultenTanimla.vue?vue&type=template&id=f3c961b4&"
import script from "./BultenTanimla.vue?vue&type=script&lang=js&"
export * from "./BultenTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports